'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reselect = require('reselect');

var _notificationSelector = require('../../../../notifications/notificationSelector');

var _currentUserSelector = require('../../../../user/currentUserSelector');

var _popupOpenSelector = require('../../../../components/popupPanel/popupOpenSelector');

var _popupOpenSelector2 = _interopRequireDefault(_popupOpenSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
exports.default = (0, _reselect.createStructuredSelector)({
    popupOpen: (0, _popupOpenSelector2.default)('notification'),

    fetchedTime: _notificationSelector.getFetchedTime,
    forcedPoll: _notificationSelector.getForcedPoll,

    isGuest: _currentUserSelector.isGuestSelector,
    currentUser: _currentUserSelector.getCurrentUser,

    notifications: _notificationSelector.modifiedElementsSelector,
    activeNotifications: _notificationSelector.activeNotificationsIdsSelector,
    notificationsCount: _notificationSelector.notificationsCountSelector,
    notificationUserIds: _notificationSelector.notificationUserIdsSelector,
    notificationsReady: _notificationSelector.notificationsReadySelector,
    errorUserIds: _notificationSelector.errorNotificationUserIds
});


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/notifications/notificationUtilSelector.js
// module id = 782
// module chunks = 0